import type { RouteRecordRaw } from 'vue-router';
import { ROLES } from '@AuthModule';

export default <RouteRecordRaw[]>[
  {
    path: 'faq',
    redirect: '/support/faq/animals',
    children: [
      {
        path: 'animals',
        name: 'faq-animals',
        component: () => import('./views/FaqAnimals.view.vue'),
      },
      {
        path: 'modules',
        name: 'faq-modules',
        component: () => import('./views/FaqModules.view.vue'),
      },
      {
        path: 'adoptions',
        name: 'faq-adoptions',
        component: () => import('./views/FaqAdoptions.view.vue'),
        meta: {
          permissions: [ROLES.ADOPTIONS],
        },
      },
      {
        path: 'medical',
        name: 'faq-medical',
        component: () => import('./views/FaqMedical.view.vue'),
      },
    ],
  },
];
